// extracted by mini-css-extract-plugin
export default {"img":"Social_img__Mi-1a"};